import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-shrink: 0;
  `,
    LayoutTitle: styled.div `
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 60px;

    font-size: 20px;
    font-weight: 700;
  `,
    LayoutProgress: styled.div `
    width: 100%;
    height: 17px;
    background: ${SEMANTIC_COLORS.DEFAULT_PROGRESS_BACKGROUND};
  `,
    Progress: styled.div `
    width: ${(props) => `${(100 * props.currentProgress) / props.totalProgress}%`};
    height: 100%;
    background: ${SEMANTIC_COLORS.DEFAULT_PROGRESS_BAR};
    border-radius: ${(props) => (props.isCompleted ? 0 : '0 31.5px 31.5px 0')};
    transition: width, 0.5s;
  `,
    Logo: styled.img `
    width: 23px;
    height: 23px;
    margin-right: 10px;
  `,
};
